<div class="dialog-box card">
  <div class="card-header">
    {{ shiftClockInOutParms?.title }}
    <span class="float-end" (click)="onCloseDialog(false)">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>
  @if (offlineMode) {
    <div class="alert alert-warning mb-3">
      Please clock in/out once the network connection has been restored.
    </div>
  }

  @if (
    shiftClockInOutParms?.lateClockIn || shiftClockInOutParms?.earlyClockOut
  ) {
    <div class="form-group input-group mb-3">
      <textarea
        class="form-control"
        rows="5"
        wrap="hard"
        [placeholder]="
          shiftClockInOutParms?.lateClockIn
            ? 'Reason for late clock in'
            : 'Reason for early clock out'
        "
        autofocus
        [(ngModel)]="shiftClockInOutParms.reason"
        id="clockInOutReasonBox"
      ></textarea>
      @if (shiftClockInOutParms?.reason) {
        <span
          class="input-group-text"
          (click)="
            clearAndFocusTextBox('clockInOutReasonBox');
            shiftClockInOutParms.reason = ''
          "
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>
  }

  @if (shiftClockInOutParms?.message) {
    <div class="p-3">
      {{ shiftClockInOutParms?.message }}
    </div>
  }

  <div class="row row-cols-2 mt-4">
    <div class="col">
      <button class="btn btn-lg w-100 btn-dark" (click)="onCloseDialog(false)">
        Cancel
      </button>
    </div>

    <div class="col">
      <button
        [disabled]="
          offlineMode ||
          shiftClockInOutParms?.lateClockIn ||
          shiftClockInOutParms?.earlyClockOut
            ? !shiftClockInOutParms?.reason
            : false
        "
        class="btn btn-primary btn-lg w-100"
        (click)="clockInOut()"
      >
        Ok
      </button>
    </div>
  </div>
</div>
